// removed by extract-text-webpack-plugin
module.exports = {"root":"SaveTag__root--3XGDP","save":"SaveTag__save--18RhD","saved":"SaveTag__saved--34zn1","icon":"SaveTag__icon--1vT2X","absolute":"SaveTag__absolute--1g0nc","bounce":"SaveTag__bounce--1Ttac"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/SaveTag/SaveTag.css
// module id = ./src/components/Library/SaveTag/SaveTag.css
// module chunks = 4